import {useEffect, useRef, useState} from 'react';

const useAutoRefresh = ({enabled, isLoading, onRefresh, intervalMs}) => {
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const onRefreshRef = useRef(onRefresh);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    onRefreshRef.current = onRefresh;
  }, [onRefresh]);

  useEffect(() => {
    if (!enabled || isLoading) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      setProgress(0);
      return;
    }

    const startTime = Date.now();
    intervalRef.current = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const nextProgress = Math.min(100, (elapsed / intervalMs) * 100);
      setProgress(nextProgress);
    }, 250);

    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      setProgress(0);
      onRefreshRef.current();
    }, intervalMs);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [enabled, isLoading, intervalMs]);

  return {progress};
};

export default useAutoRefresh;
